import { useMainAppContext } from '@repo/ccc-main-app-lib/src/context/MainAppContext/useMainAppContext.ts'
import { LoginPage } from '@repo/internal-tools-app-lib/src/lib/LoginPage.tsx'
import { createFileRoute } from '@tanstack/react-router'

/**
 * All fields must be optional, because in reality, users can enter the page url directly
 * without specifying any search params.
 * Making them optional allows us to handle that case gracefully.
 */
type LoginRouteSearchParams = {
  redirectUrl?: string
}

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, string>): LoginRouteSearchParams => {
    return { redirectUrl: search.redirectUrl }
  },
  component: LoginRoute,
})

function LoginRoute() {
  const { redirectUrl } = Route.useSearch()
  const { processedBasePath } = useMainAppContext()

  const absoluteHomeUrl = window.location.origin + processedBasePath

  return (
    <LoginPage
      // If redirectUrl is not provided, default to the home URL.
      absoluteRedirectUrl={redirectUrl ?? absoluteHomeUrl}
    />
  )
}
